import { observable, action, computed } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../../services/web/agent';
import LDAPStore from './ldapStore';
import LDAPValidatorStore from './ldapValidtor';

class RootLdapStore {

    stores = [];
    validators = [];
    @setter @observable ldapServers;
    
    @observable getLDAPServersErrorMessage;
    @observable getLDAPServersProgress;

    constructor() {

        this.ldapStore = new LDAPStore();
        this.ldapValidator = new LDAPValidatorStore();
    }

    @action getLDAPServers() {

        this.getLDAPServersProgress = true;
        
        return agent.LDAPServers.getLDAPServers()
            .then(action((servers) => {

                this.ldapServers = servers;
            }))
            .catch(action((err) => {

                if (err && err.response && err.response.text) {
    
                    this.getLDAPServersErrorMessage = JSON.parse(err.response.text).Message;
                }
        
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }))
            .finally(action(() => {

                this.getLDAPServersProgress = false;
            }));
    }

    @action addStore(serverId) {

        const r = this.stores.filter((s) => s.serverId == serverId);

        if (r.length == 0) {
         
            this.stores.push({
                serverId: serverId,
                ldapEditStore: new LDAPStore()
            });
        }
    }

    @action getStore(serverId) {

        const r = this.stores.filter((s) => s.serverId == serverId);

        if (r.length > 0) {
         
            return r[0];
        }
    }

    @action addValidatorStore(serverId) {

        const y = this.validators.filter((v) => v.serverId == serverId);

        if (y.length == 0) {
            
            this.validators.push({
                serverId: serverId,
                ldapValidator: new LDAPValidatorStore()
            });
        }
    }

    @action getValidatorStore(serverId) {
        
        const y = this.validators.filter((v) => v.serverId == serverId);

        if (y.length > 0) {
         
            return y[0];
        }
    }

    @action visibleLdapServersForMapping() {

        const servers = this.ldapServers.filter((server) => {
                        
            return server.active === true 
                        && server.synchronizationEnabled === true
                            && server.advancedTeamAndRoleMappingEnabled === true;
        });

        return servers;
    }

    @computed get shouldDispalyLdapMapping() {

        return this.visibleLdapServersForMapping().length > 0;
    }
}

export default new RootLdapStore();